import { VehicleMaintenanceDto } from "./vehicleMaintenance";

export enum MaintenanceReminderStatus {
    Incoming = "Incoming",
    Approaching = "Approaching",
    Exceeded = "Exceeded",
    AwaitingApproval = "AwaitingApproval",
    Completed = "Completed"
}

export const MaintenanceReminderStatesEditAllowed = [
    MaintenanceReminderStatus.Incoming,
    MaintenanceReminderStatus.Approaching
];

export interface VehicleMaintenanceReminderDto {
    id?: string;
    ownerId?: string;
    vehicleMaintenanceId?: string;
    vehicleMaintenance?: VehicleMaintenanceDto;
    status: MaintenanceReminderStatus;
    remindByDate: boolean;
    remindByOdometerReading: boolean;
    datesBeforeReminderStarts?: number;
    odometerReadingForMaintenance?: number;
    distanceBeforeReminderStarts?: number;
}

export interface VehicleMaintenanceReminderQueryParameters {
    states?: MaintenanceReminderStatus[];
}
